var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgService5 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 173,
    height: 172,
    rx: 18.5,
    stroke: "url(#paint0_linear_1537_1331)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 129H47V33H126.2V76.6364M47 85.3636H108.6M47 107.182H91M47 63.5455H126.2M108.6 46.0909H113V50.4545H108.6V46.0909Z",
    stroke: "url(#paint1_linear_1537_1331)",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.049 111.23L129.726 113.681C137.896 112.455 144.432 105.919 144.432 97.3405C144.432 94.8894 144.024 92.8468 143.207 90.8043L131.36 102.651L122.781 94.0724L134.628 82.2255C132.585 81.4085 130.543 81 128.092 81C119.105 81 111.751 88.3532 111.751 97.3405C111.751 99.7915 112.16 101.834 112.977 103.877L96.2561 120.562L91.9994 125C91.9994 125 90.4979 126.5 87.4962 130.5C85.9982 132.496 86.0032 135.833 87.4995 137.5C89.9781 140.262 94.9546 138.958 95.9972 138C100.647 133.729 99.2112 135 99.2112 135L126.049 111.23ZM90 134C90 133.296 90.3887 132.849 91 132.5C91.6781 132.112 92.3219 132.112 93 132.5C93.6113 132.849 94 133.296 94 134C94 134.704 93.6113 135.151 93 135.5C92.3219 135.888 91.6781 135.888 91 135.5C90.3887 135.151 90 134.704 90 134Z",
    fill: "url(#paint2_linear_1537_1331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_1331",
    x1: 88,
    y1: 0,
    x2: 88,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1537_1331",
    x1: 86.6,
    y1: 33,
    x2: 86.6,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1537_1331",
    x1: 119.707,
    y1: 81,
    x2: 119.707,
    y2: 138.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgService5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service5.bdcbed2a9197e82300d2d7b9a42e80f3.svg";